<template>
  <div class="approveAndSignWrap">
    <div class="title">设置合同审签信息</div>
    <el-form
      ref="ruleForm"
      :model="formData"
      label-width="120px"
      :inline="true"
    >
      <el-row>
        <el-col :span="10">
          <el-form-item label="审签表名称" prop="signTableName">
            <el-input v-model="formData.signTableName"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="合同名称" prop="contractName">
            <el-input v-model="formData.contractName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="经办部门" prop="handleDeptName">
            <!--						<el-input v-model="formData.handleDeptName" ></el-input>-->
            <el-cascader
              ref="cascaderAddr"
              v-model="formData.handleDeptId"
              :options="subDeptList"
              :props="defaultProps"
              @change="handleChangeDept"
              :placeholder="formData.handleDeptName"
              @active-item-change="handleChangeDept"
              change-on-select
              style="width: 100%"
            ></el-cascader>
          </el-form-item>
        </el-col>
        <!--				<el-button type="primary" class="marginLeft8">选择</el-button>-->
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="合同编号" prop="contractSerialNumber">
            <el-input
              v-model="formData.contractSerialNumber"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="日期">
            <el-date-picker
              v-model="formData.signDate"
              type="date"
              placeholder="请选择日期"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="我方单位">
            <el-input v-model="formData.partyA" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="20">
          <el-form-item label="相对方单位">
            <el-input
                      type="textarea"
                      :rows="2"
                      v-model="formData.partyB"
                      :readonly="true"
                    ></el-input>
            <!-- <el-input v-model="formData.partyB" readonly></el-input> -->
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="合同项目">
            <el-input v-model="formData.projectName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item label="合同金额（元）">
            <el-input v-model="formData.contractAmount" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="所用印章">
            <el-select
              v-model="formData.sealType"
              filterable
              default-first-option
              placeholder="请选择"
              style="width: 100%"
            >
              <el-option label="行政印章" value="行政印章"></el-option>
              <el-option label="合同专用章" value="合同专用章"></el-option>
              <el-option label="法人章" value="法人章"></el-option>
              <el-option label="合同备案章" value="合同备案章"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="合同签订依据">
            <el-input type="textarea" v-model="formData.signAccording"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10" class="mulrow">
          <el-form-item label="合同说明（合同目的、双方主要权利义务等）">
            <el-input type="textarea" v-model="formData.agreeOn"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="经办部门负责人" prop="handleChargeUserName">
            <el-input
              v-model="formData.handleChargeUserName"
              readonly
            ></el-input>
          </el-form-item>
        </el-col>
        <el-button
          type="primary"
          class="marginLeft8"
          @click="showApplyUserDia('handleChargeUserName')"
          >选择
        </el-button>
      </el-row>
      <el-row>
        <el-col :span="10">
          <el-form-item label="经办人" prop="handleUserName">
            <el-input v-model="formData.handleUserName" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-button
          type="primary"
          class="marginLeft8"
          @click="showApplyUserDia('handleUserName')"
          >选择</el-button
        >
      </el-row>
      <template v-for="(item, index) in formData.approveInfoList">
        <el-row :key="item.id">
          <el-col :span="10">
            <el-form-item :label="`审批人${index + 1}`" prop="serialNumber">
              <div class="approverWrap">
                <template v-if="item.opinion">
                  <div class="approverSingleWrap">
                    <div class="comments">
                      {{ item.opinion }}
                    </div>
                    <div class="user">
                      {{ item.approveUserName }}
                    </div>
                  </div>
                </template>
                <template v-else>
                  <div>
                    {{ item.approveUserName }}
                  </div>
                </template>
              </div>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <div class="checkboxWrap">
              <el-checkbox v-model="item.isPrint" style="width: 100px" label="1"
                >打印
              </el-checkbox>
            </div>
            <el-form-item label="打印显示部门">
              <PrintDeptSelectComponent
                :value="item.deptKey"
                :placeholder-name="item.deptKeyName"
                @handleSave="
                  (e) => {
                    handleChangeDeptCom(e, index);
                  }
                "
              ></PrintDeptSelectComponent>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </el-form>
    <div class="bottomBtn">
      <el-button type="primary" @click="print">打印预览</el-button>
      <el-button type="primary" @click="submit">保存</el-button>
    </div>
    <ApplyUserDialog
      @dialogClose="applyUserDiaVisible = false"
      @SaveApplyUser="saveApplyUser"
      @close="closeDialog"
      :applyUserName="applyUserName"
      :applyUserDiaVisible="applyUserDiaVisible"
    ></ApplyUserDialog>
    <ApproveAndSignPrint
      :visible.sync="printVisible"
      :printData="formData"
      v-if="printVisible"
    >
    </ApproveAndSignPrint>
  </div>
</template>

<script>
import {
  getServiceContractDetailService,
  updateSubContractSignService,
} from "@/services/allContractServices"; //获取一条劳务合同项目信息
import {
  getOrgIdService, //根据用户id获取组织id
  getsubDeptService, //获取项目部二级项目级联列表
  getDeptListService, //根据组织获取项目部一级数据下拉列表
} from "@/services/sysSettingService";
import ApplyUserDialog from "../commonCell/ApplyUserDialog";
import ApproveAndSignPrint from "./ApproveAndSignPrint";
// import DeptSelectComponent from "./DeptSelectComponent";
import PrintDeptSelectComponent from "./PrintDeptSelectComponent";

export default {
  name: "approveAndSign",
  props: {
    itemId: {
      type: Number,
    },
    approveType: {
      type: String,
    },
  },
  components: {
    ApplyUserDialog,
    ApproveAndSignPrint,
    // DeptSelectComponent,
    PrintDeptSelectComponent,
  },
  data() {
    return {
      formData: {},
      applyUserDiaVisible: false, //选择申请人弹窗
      applyUserDiaType: "", //申请人
      applyUserName: "",
      subDeptList: [], //部门列表
      defaultProps: {
        label: "name",
        value: "id",
        lazy: true,
        lazyLoad(node, resolve) {
          const param = {};
          if (undefined != node.value) {
            param.deptId = node.value;
            getsubDeptService(param).then((res) => {
              if (res.code == 10000000) {
                const nodes = res.data;
                nodes.forEach((item) => {
                  item.leaf = item.isLeaf == 1;
                });
                resolve(nodes);
              } else {
                this.$message.error(res.msg);
              }
            });
          }
        },
      },
      printVisible: false,
    };
  },
  watch: {
    itemId: {
      handler: function (newVal) {
        if (newVal) {
          this.getsubServiceContractDetail(this.itemId);
        }
      },
      immediate: true,
    },
  },
  created() {
    this.getProjectClubList(0); //获取部门一级下拉列表
  },
  methods: {
    //获取一条劳务合同信息
    getsubServiceContractDetail(id) {
      getServiceContractDetailService({ id })
        .then((res) => {
          if (res.code == 10000000) {
            const data = res.data?.subContractSignVO ?? {signTableName:'合同审核审批表'};
            const approveInfoList = data?.approveInfoList || [];
            this.formData = {
              ...data,
              approveInfoList,
            };
            if (
              res.data.otherPartyBList &&
              res.data.otherPartyBList.length > 0
              ) {
               let str =res.data.otherPartyBList.map(
                  (em) => {
                    return em.partyB;
                  }
                );
                this.formData.partyB=this.formData.partyB+'、'+str.join('、')
              }
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch((error) => {
          this.$alert(error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    //获取项目部下拉列表数据
    getProjectClubList(deptId) {
      let reqParam = {
        pid: deptId,
        orgId: sessionStorage.getItem("orgId"),
      };
      getDeptListService(reqParam).then(
        (res) => {
          if (res.code == 10000000) {
            this.subDeptList = res.data;
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$alert("系统异常", "提示", {
            confirmButtonText: "确定",
          });
        }
      );
    },
    submit() {
      const approveInfoList = this.formData.approveInfoList || [];
      const isFull = approveInfoList.every((i) => i.deptKey);
      if (!isFull) {
        this.$message.error("请选择打印部门");
        return;
      }
      updateSubContractSignService({
        ...this.formData,
        subContractId: this.itemId,
      })
        .then((res) => {
          if (res.code == 10000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert(res.msg, "确定");
          }
        })
        .catch((err) => {
          this.$message.error("网络请求失败");
        });
    },
    print() {
      this.printVisible = true;
      this.$emit("handlePrint", {
        formData: this.formData,
        approveList: this.approveList,
      });
    },
    showApplyUserDia(type) {
      this.applyUserDiaType = type;
      this.applyUserDiaVisible = true;
    },
    closeDialog() {
      this.applyUserDiaVisible = false;
    },
    //部门数据改变时更新数据
    handleChangeDept(value) {
      this.formData.handleDeptId = value[value.length - 1];
      let labels = this.$refs["cascaderAddr"].getCheckedNodes()[0].pathLabels;
      this.formData.handleDeptName = labels[labels.length - 1];
    },
    handleChangeDeptCom(e, index) {
      this.$set(this.formData.approveInfoList[index], "deptKey", e.value);
      this.$set(this.formData.approveInfoList[index], "deptKeyName", e.label);
    },
    //存储申请人
    saveApplyUser(selectItems) {
      //  部门负责人
      if (this.applyUserDiaType === "handleChargeUserName") {
        this.formData.handleChargeUserName = selectItems.applyUserName;
        this.formData.handleChargeUserId = selectItems.applyUserId;
        this.formData.handleChargeUserSign=selectItems.signUrl;
        //经办人
      } else if (this.applyUserDiaType === "handleUserName") {
        this.formData.handleUserName = selectItems.applyUserName;
        this.formData.handleUserId = selectItems.applyUserId;
        this.formData.handleUserSign=selectItems.signUrl;

      }
      this.applyUserDiaType = "";
      this.applyUserDiaVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.approveAndSignWrap {
  .title {
    margin: 10px 0;
  }
  // /deep/.el-form-item__content {
  //       width: calc(100% - 190px);}
  .marginLeft8 {
    margin-top: 2px;
  }
  
   /deep/.el-form-item__label {
      line-height: 36px;
    }
  

  .approverWrap {
    border: 1px solid #dcdfe6;
    display: flex;
    justify-content: space-around;
    align-items: center;

    .approverSingleWrap {
      position: relative;
      flex: 1;

      .comments {
        height: 80px;
        text-align: center;
        line-height: 80px;
      }

      .user {
        text-align: right;
        position: absolute;
        line-height: 14px;
        right: 18px;
        bottom: 5px;
      }
    }
  }

  .checkboxWrap {
    width: 110px - 12px;
    text-align: right;
  }

  .bottomBtn {
    width: 80%;
    text-align: center;

    .el-button {
      margin: 0 8px;
    }
  }
}
</style>
